import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { filter, map, pipe, switchMap } from 'rxjs';

import { Injectable } from '@angular/core';
import { GetMineLookBooksGQL } from './graphql';

import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

@Injectable({
  providedIn: 'root',
})
export class LookBookEditorService {
  constructor(
    private getMineLookBooksGQL: GetMineLookBooksGQL,
    private organizationService: OrganizationService,
  ) {}

  getLookBookDetails(lookBookId: string) {
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) => {
        return this.getMineLookBooksGQL
          .watch({ variables: { organizationId } })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['getMineLookBooks']),
            map((lookBooks) =>
              lookBooks.find((lookBook) => lookBook.lookBookId === lookBookId),
            ),
          );
      }),
    );
  }
}
